import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { EMPTY_PROPS } from '../../helpers/types';

var InfoContentSimple = function InfoContentSimple(_ref) {
  var as = _ref.as,
      forwardedAs = _ref.forwardedAs,
      title = _ref.title,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 1 : _ref$lines,
      _ref$fixedHeight = _ref.fixedHeight,
      fixedHeight = _ref$fixedHeight === void 0 ? false : _ref$fixedHeight,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? null : _ref$prefix,
      _ref$suffix = _ref.suffix,
      suffix = _ref$suffix === void 0 ? null : _ref$suffix,
      _ref$props = _ref.props,
      textProps = _ref$props === void 0 ? EMPTY_PROPS : _ref$props,
      Component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "forwardedAs", "title", "lines", "fixedHeight", "prefix", "suffix", "props", "component"]);

  return title || prefix || suffix ? /*#__PURE__*/React.createElement(React.Fragment, null, prefix, /*#__PURE__*/React.createElement(Component, _extends({
    as: forwardedAs != null ? forwardedAs : as,
    ellipsis: lines === 1,
    fixedHeight: fixedHeight,
    lines: lines === 0 || lines === 1 ? undefined : lines
  }, props, textProps), title || "\u200C"), suffix) : null;
};

export default InfoContentSimple;